import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';

import { isNullOrUndefined } from '@utils/object';

function Scroller({
  className,
  fetchMore,
  hasMore,
  loader,
  enabled,
  children,
  parentRef,
}) {
  if (!enabled) return <div className={className}>{children}</div>;

  if (isNullOrUndefined(fetchMore) || isNullOrUndefined(hasMore))
    throw new Error('fetchMore and hasMore are required');

  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={fetchMore}
      hasMore={hasMore}
      initialLoad={false}
      loader={loader}
      className={className}
      useWindow={!parentRef}
      getScrollParent={() => parentRef?.current}
    >
      {children}
    </InfiniteScroll>
  );
}

Scroller.defaultProps = {
  enabled: true,
};

Scroller.propTypes = {
  fetchMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loader: PropTypes.node,
  enabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  parentRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default styled(Scroller)``;
